module.exports = __webpack_public_path__ + "img/03_uk.803af40e.svg";